import { useStyles } from "./FrequencyCumulativeLengthTooltip.styles";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Typography, Tooltip } from "@mui/material";

const FrequencyCumulativeLengthTooltip = ({ lastSevenDaysDowntime }: { lastSevenDaysDowntime?: number }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Tooltip
            placement="top-start"
            PopperProps={{
                className: classes.tooltip,
            }}
            title={
                <Typography className={classes.tooltipTexts}>
                    {t("rca.rca_library.rca_detail.downtime_last_seven_days_length")} {lastSevenDaysDowntime || 0}{" "}
                    {t("rca.rca_library.rca_detail.minutes")}
                </Typography>
            }
        >
            <InfoOutlinedIcon className={classes.infoIcon} />
        </Tooltip>
    );
};

export default FrequencyCumulativeLengthTooltip;
